import { makeBuildOptimizedSrc } from './ImageOptimizer';

const logoUrl =
  'https://acloudguru-content-assets-production.s3-accelerate.amazonaws.com/1660798159214-ACG-logo_ACG-OrangeWhite.png';
const withLaLogoUrl =
  'https://acloudguru-content-assets-production.s3-accelerate.amazonaws.com/1612319787407-la-and-acg.png';

const logoDesktopTransforms = width =>
  makeBuildOptimizedSrc({
    width,
    format: 'auto'
  });

const imagePaths = {
  logoDesktop: isLA => (isLA ? logoDesktopTransforms(93)(withLaLogoUrl) : logoDesktopTransforms(200)(logoUrl))
};

export { imagePaths };
